import { Button } from 'src/ui/components/Button';
import { Modal, ModalBase } from 'src/ui/components/Modal/Modal';
import {
  GET_ALL_APPOINTMENTS_SLOTS_OF_DAY,
  GET_ALL_APPOINTMENTS_SLOTS_OF_MONTH,
  RESCHEDULE_APPOINTMENT,
} from 'src/graphql/Appointments';
import { useGQLLazyQuery, useGQLMutation } from 'src/ui/utils/graphql';
import {
  Appointment,
  AppointmentSlot,
  MutationRescheduleAppointmentArgs,
} from 'src/gql/graphql';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toLocalISOString } from 'src/ui/utils/Date';
import { DatePicker } from 'src/ui/components/DatePicker/DatePicker';
import { Dropdown } from 'src/ui/components/Dropdown/Dropdown';
import styles from './MoveAppointmentModal.module.scss';
import { Heading } from '../../../../../../ui/components/Heading/Heading';
import { Input } from '../../../../../../ui/components/Input/Input';
import { Icon } from '../../../../../../ui/components/Icon/Icon';

interface MoveAppointmentModalI extends ModalBase {
  appointment: Appointment;
}

export const MoveAppointmentModal = ({
  isOpen,
  setIsOpen,
  appointment,
}: MoveAppointmentModalI) => {
  const { register, setValue, getValues, handleSubmit } = useForm<{
    newDay: string;
    newTime: string;
  }>();
  const { data: slotsInAMonth, lazy: lazySlotsInAMonth } = useGQLLazyQuery<
    number[],
    { companyId: string; serviceId: string; month: string }
  >(GET_ALL_APPOINTMENTS_SLOTS_OF_MONTH, {
    onCompleted: () => {},
  });
  const { data: slotsInADay, lazy: lazySlotsInADay } = useGQLLazyQuery<
    AppointmentSlot[],
    { companyId: string; serviceId: string; day: string }
  >(GET_ALL_APPOINTMENTS_SLOTS_OF_DAY, {
    onCompleted: () => {},
  });
  const { mutation: lazyRescheduleAppointment } = useGQLMutation<
    Appointment,
    MutationRescheduleAppointmentArgs
  >(RESCHEDULE_APPOINTMENT, {
    onCompleted: (data) => {
      console.log('Appointment rescheduled:', data);
      setIsOpen(false);
    },
    onError: (error) => {
      console.error('Error rescheduling appointment:', error);
    },
  });

  useEffect(() => {
    console.log('appointment', appointment);

    if (appointment) {
      lazySlotsInAMonth({
        variables: {
          companyId: appointment?.Company?.id,
          serviceId: appointment?.service.id,
          month: new Date().toISOString().split('T')[0],
        },
      });
    }
  }, [appointment]);

  const onSubmit = (data: { newDay: string; newTime: string }) => {
    console.log('Appointment data', data);
    const dayParsed = data.newDay.split('/');

    const day = dayParsed?.[0];
    const month = dayParsed?.[1];
    const year = dayParsed?.[2];
    const newDate = new Date(`${month}-${day}-${year}`);
    const newFormat = newDate.toISOString().split('T')?.[0];

    lazyRescheduleAppointment({
      variables: {
        appointmentId: appointment.id,
        dayOfAppointment: newFormat,
        hourOfAppointment: data.newTime,
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className={styles.root}>
        <Heading className={styles.header} headingLevel="h2">
          Mover Cita
        </Heading>
        <div className={styles.content}>
          <div className={styles.old}>
            <Heading className={styles.title} headingLevel="h3">
              Cita Actual
            </Heading>
            <div className={styles.values}>
              <Input
                label="Día Seleccionado"
                placeholder={
                  new Date(Number(appointment?.dayOfAppointment))
                    .toISOString()
                    .split('T')[0]
                }
                readOnly
              />
              <Input
                label="Hora Seleccionada"
                placeholder={
                  new Date(Number(appointment?.dayOfAppointment))
                    .toISOString()
                    .split('T')[1]
                    .split('.')[0]
                }
                readOnly
              />
            </div>
          </div>
          <div className={styles.icon}>
            <Icon type="change" />
          </div>
          <form id="reschedule-form" className={styles.new}>
            <Heading className={styles.title} headingLevel="h3">
              Nuevo Día y Hora
            </Heading>
            <div className={styles.values}>
              <DatePicker
                register={register}
                firstDateAvailable={new Date(toLocalISOString(new Date()))}
                lastDateAvailable={(() => {
                  const date = new Date();
                  date.setDate(new Date().getDate() + 1200);
                  return date;
                })()}
                label="Día de cita"
                defaultDate={new Date(toLocalISOString(new Date()))}
                name="newDay"
                personalizeDays={slotsInAMonth?.map((percentaje) => {
                  if (percentaje > 0.66 && percentaje <= 1) return 'success';
                  if (percentaje > 0.33 && percentaje <= 0.66) return 'warning';
                  if (percentaje > 0 && percentaje <= 0.33) return 'error';

                  return 'disabled';
                })}
                onMonthChange={(month: string) => {
                  lazySlotsInAMonth({
                    variables: {
                      companyId: appointment?.Company?.id,
                      serviceId: appointment?.service.id,
                      month,
                    },
                  });
                }}
                onDayChange={(day: string) => {
                  lazySlotsInADay({
                    variables: {
                      companyId: appointment?.Company?.id,
                      serviceId: appointment?.service.id,
                      day,
                    },
                  });
                }}
                setValue={setValue}
              />
              <Dropdown
                SetValue={setValue}
                readOnly={!(slotsInADay && getValues('newDay') !== '//')}
                name="newTime"
                label="Horario"
                placeholder="Selecciona el horario deseado"
                register={register('newTime', {
                  required: {
                    value: true,
                    message: 'El tiempo es requerido',
                  },
                  minLength: {
                    value: 4,
                    message: 'El tiempo es requerido',
                  },
                })}
                items={slotsInADay?.map((s) => ({
                  value: s.startHour,
                  placeholder: s.startHour,
                }))}
              />
            </div>
          </form>
        </div>
        <div className={styles.actions}>
          <Button onClick={() => setIsOpen(false)}>Cerrar</Button>
          <Button
            btnStyle="secondary"
            type="submit"
            onClick={handleSubmit(onSubmit)}
            form="reschedule-form"
          >
            Mover Cita
          </Button>
        </div>
      </div>
    </Modal>
  );
};
